export default __webpack_public_path__ + "static/media/11613989115-1.27661423.jpg";